module.exports = __webpack_public_path__ + "static/media/chess-clock-alt.f9abbd50.svg";